module.exports = __webpack_public_path__ + "static/media/sultron.53aef9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/cenicilla_pepino/preventiva/sultron.png
// module id = 2103
// module chunks = 3